export const linkableCell = {
    color: '#2b78e4',
    cursor: 'pointer'
};
